const en = {
	project: 'project',
	projectList: 'projects',
	number: 'number',
	searchCriteria: 'search criteria',
	pEnterName: 'please enter a name',
	printerInformation: 'printer information',
	name: 'name',
	domainName: 'domain name',
	empty: 'empty',
	search: 'search',
	projectName: 'project name',
	splitServer: 'split server',
	startAndEndTime: 'start and end time',
	state: 'state',
	speedOfProgress: 'speed of progress',
	overview: 'overview',
	noSearchSeeOthers: 'no search results yet. Lets see others~',
	currentProject: 'current project',
	projectExperience: 'project experience',
	projectOverview: 'project overview',
	projectManager: 'project manager',
	removed: 'removed',
};

export default en;
